import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  const gateToken = localStorage.getItem("gate_token");
  if (gateToken) {
    config.headers["X-Gate-Token"] = gateToken;
  }
  return config;
});

export default api;
export { API_BASE };
